import React, { useState } from "react";
import Nav from "./Nav";
import NavTop from "./NavTop";

const ScrollNavbar = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 100) {
      setVisible(true);
    } else if (scrolled <= 100) {
      setVisible(false);
    }
  };


  window.addEventListener("scroll", toggleVisible);

  return (
    <div>
      <div  style={{ display: visible ? 'inline' : 'none' }}>
        <div className="scroll-navbar">
          <NavTop/>
          <Nav />
        </div>
      </div>
    </div>
  );
};

export default ScrollNavbar;
